// Function to initialize event listeners
function initColorSwatchTracking() {
    // Select all color swatch elements
    var colorSwatches = document.querySelectorAll('.color-swatch-container');

    // Add click event listener to each swatch
    colorSwatches.forEach(function(swatch) {
        swatch.addEventListener('click', function(event) {
            // Find the color name element within the clicked swatch
            var colorNameElement = swatch.querySelector('.color-swatch-color-name');
            var colorName = colorNameElement ? colorNameElement.textContent.trim() : 'Unknown Color';

            // Traverse up to the closest info-container and then find the product name
            var productNameElement = swatch.closest('.info-container').querySelector('.title.fs-product-title');
            var productName = productNameElement ? productNameElement.textContent.trim() : 'Unknown Product';

            // Push an event to the GTM data layer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'colorSwatchClick',
                'colorName': colorName,
                'productName': productName
            });
        });
    });
}

// Initialize the tracking when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', initColorSwatchTracking);